import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

import { viewCrowdFundPath } from 'src/config/paths'
import { env } from 'src/env/client.mjs'
import { NotFound } from 'src/pages/404/404'
import { trpc } from 'src/utils/trpc'

const ViewRegistry: NextPage = () => {
  const router = useRouter()
  const { registryUri } = router.query as { registryUri: string }

  const { data, isLoading } = trpc.useQuery([
    'registries.getByUri',
    { uri: registryUri }
  ])

  const registry = data?.registry

  useEffect(() => {
    if (registry?.IsCampaign) {
      router.replace(viewCrowdFundPath({ routeParams: { uri: registryUri } }))
    }
  }, [registry?.IsCampaign, registryUri, router])

  if (isLoading) return null
  if (!registry) return <NotFound />
  if (registry.IsCampaign) return null

  return (
    <SanityContentPage
      slug='registry-detail'
      title={registry.Name || 'Tree Registry'}
      metaTitle={registry.Name || 'Tree Registry'}
      metaDescription={registry.Description || 'Give a gift that counts'}
      image={`${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${registry.Hero}`}
      showBreadcrumbs={false}
    />
  )
}

export default ViewRegistry
